import { Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { ItemAccessDialogComponent } from 'src/app/dialogs/item/item-access-dialog/item-access-dialog.component';
import { CNMedication } from 'src/app/models/cnmedication';
import { CNTreatment } from 'src/app/models/cntreatment';
import { CNTreatmentKine } from 'src/app/models/cntreatmentkine';
import { CNTreatmentLogo } from 'src/app/models/cntreatmentlogo';
import { ContactService } from 'src/app/services/contact.service';
import { TreatmentService } from 'src/app/services/treatment.service';
import { TypeManagerService } from 'src/app/services/type-manager.service';
import { RecordContainerMode } from '../../record/record-container/record-container.component';

declare var Ext: any;

@ManageType('MedicationRowComponent')
@Component({
  selector: 'app-medication-row',
  templateUrl: './medication-row.component.html',
  styleUrls: ['./medication-row.component.scss']
})
export class MedicationRowComponent implements OnInit {

  public isMedication = false;
  public isTreatment = false;
  public sessions: boolean[] = [];

  @Input() mode: RecordContainerMode = RecordContainerMode.compact;

  @Output() updated = new EventEmitter<CNMedication | CNTreatment>();

  private treatment: CNMedication | CNTreatment;

  constructor(public medications: TreatmentService, private dialog: MatDialog, private ngZone: NgZone,
              private typeManager: TypeManagerService) { }

  ngOnInit(): void {
  }

  @Input() set record(treatment: CNMedication | CNTreatment) {
    this.treatment = treatment;
    if (this.treatment instanceof CNMedication) {
      this.isMedication = true;
    }
    if (this.treatment instanceof CNTreatment) {
      this.isTreatment = true;
      if (this.treatment instanceof CNTreatmentKine) {
        this.sessions = Array.from(this.treatment.sessions.values());
      }
    }
  }

  get record(): CNMedication | CNTreatment {
    return this.treatment;
  }

  getDate() {
    return moment(this.record.date).format('DD/MM/YYYY');
  }

  editMedication() {
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const medication = new Ext.CNMedication(this.record.id);
        medication.on('itemLoaded', (item) => {
          const medicationWindow = new Ext.CNMedicationWindow({
            medication: item
          });
          medicationWindow.on('medicationUpdated', () => {
            this.ngZone.run(() => {
              this.updated.emit(this.record);
              this.medications.reloadAllSubjects();
            });
          });
          medicationWindow.show();
        });
      });
    });
  }

  editTreatment() {
    if (this.typeManager.typeMap('TreatmentDialogComponent')) {
      const componentFactory = this.typeManager.typeMap('TreatmentDialogComponent');
      const dialogRef = this.dialog.open(componentFactory, {
          data: {
            treatment: this.treatment
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // save treatment
          if (result instanceof CNTreatment) {
            result.update().subscribe(() => {
              this.medications.reloadAllSubjects();
            });
          }
        }
      });
    }
  }

  get content() {
    return this.record.value;
  }

  get comment() {
    return this.record.getProperty('Comment');
  }

  get startDate() {
    return (this.record.startDate) ? moment(this.record.startDate).format('DD/MM/YYYY') : '';
  }

  get endDate() {
    return (this.record.endDate) ? moment(this.record.endDate).format('DD/MM/YYYY') : '';
  }

  get active(): boolean {
    return (this.record.endDate) ? moment().isAfter(moment(this.record.endDate)) : false;
  }

  get risk(): boolean {
    return (this.record.getProperty('Risk') === 'Yes') ? true : false;
  }

  get chronic(): boolean {
    return (this.record.getProperty('Chronic') === 'Yes') ? true : false;
  }

  poso(index: string): string {
    return this.record?.getProperty('poso' + index);
  }

  toggleRisk() {

  }

  toggleChronic() {

  }

  openAccess() {
    const dialogRef = this.dialog.open(ItemAccessDialogComponent, {
      data: {
        item: this.record
      },
      maxWidth: '60%',
      minWidth: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  logoProgressBarStyle(): object {
    if (this.treatment instanceof CNTreatmentLogo) {
      const width = Math.floor((this.treatment.sessionDone / this.treatment.sessionCount) * 100);
      return  {height: '7px', width: width + '%', 'background-color': 'lightgreen'};
    }
  }
}
